import * as React from 'react';
import { withRoutes } from './withRoutes';
import { RouteDeclaration } from './routes.types';

export const createRouter = <R extends unknown>(routes: RouteDeclaration<R>[]) =>
    withRoutes(routes)((props) => <>{props.routes}</>);
